import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './shared/contexts/AuthContext';
import CustomerPortal from './portals/customer/pages/CustomerPortalComponent';
import TravelPaymentPortal from './portals/travel-payment/pages/TravelPaymentPortalComponent';
import AdminPortal from './portals/admin/pages/AdminPortalComponent';
import { syncUtmCookieFromUrl } from './shared/utils/utmUtils';

// Get base URL from environment variables
const BASE_URL = import.meta.env.VITE_APP_BASE_URL || '/travel-portal';

function App() {
  useEffect(() => {
    // Refresh the UTM cookie (1hr expiry) whenever the app is hit with UTM params in the URL
    syncUtmCookieFromUrl();
  }, []);

  return (
    <AuthProvider>
      <Router basename={BASE_URL}>
        <div className="App">
          <Routes>
            <Route path="/" element={<CustomerPortal />} />
            
            {/* Basic customer portal routes */}
            <Route path="customer-portal" element={<CustomerPortal />} />
            <Route path="customer-portal/*" element={<CustomerPortal />} />
            
            {/* CRITICAL FIX: Add missing travel flow routes */}
            <Route path="customer-portal/travel-information" element={<CustomerPortal />} />
            <Route path="customer-portal/travel-details" element={<CustomerPortal />} />
            <Route path="customer-portal/email-validation" element={<CustomerPortal />} />
            
            {/* Specific client information routes */}
            <Route path="customer-portal/client-information" element={<CustomerPortal />} />
            <Route path="customer-portal/client-information/:planType" element={<CustomerPortal />} />

            {/* Email verification routes */}
            <Route path="customer-portal/email/verified" element={<CustomerPortal />} />
            <Route path="customer-portal/email/verified/plan-details" element={<CustomerPortal />} />
            
            {/* Payment result routes */}
            <Route path="customer-portal/payment-result/success" element={<CustomerPortal />} />
            <Route path="customer-portal/payment-result/failure" element={<CustomerPortal />} />
            
            {/* Terms and Conditions route */}
            <Route path="customer-portal/terms-conditions" element={<CustomerPortal />} />
            
            {/* Privacy Statement route */}
            <Route path="customer-portal/privacy-statement" element={<CustomerPortal />} />
            
            {/* Transaction validation routes */}
            <Route path="customer-portal/transaction/validation-success" element={<CustomerPortal />} />
            <Route path="customer-portal/transaction/validation-invalid" element={<CustomerPortal />} />
            
            {/* Other portals */}
            <Route path="/travel-payment-portal" element={<TravelPaymentPortal />} />
            <Route path="/admin-portal" element={<AdminPortal />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;